import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { LoadBaseRdm } from 'src/app/shared-resources/store/base.action';

@Injectable({
  providedIn: 'root'
})
export class CommonStoreService {

  constructor(
    private store: Store
  ) { }

  updateStoreData(countriesRefType: string): void {
    this.store.dispatch(new LoadBaseRdm([countriesRefType], 'login', 'public'));
  }
}
